export const ANDROID_APP_ID = '5';
export const IOS_APP_ID = '4';
export const IPAD_APP_ID = '3';
